

import { initializeMap, customIcon, addNewMarker, getCampuses, createNewCampusBox } from '../modules/map';
import '../modules/consultationForm';
import testimonialsSlider from '../modules/testimonials';
import { gallery, openMediaInModal } from '../modules/gallery';


function changeContactsSectionOnMOb() {
  if (innerWidth < 993) {
    const contactsWrapper = document.querySelector('#school-contacts .two-column');
    if (contactsWrapper) {
      contactsWrapper.appendChild(contactsWrapper.querySelector('.social-media'))
    }
  }
}

function mapWithCampuses() {
  const schoolSlug = location.pathname.split('/').pop();

  getCampuses('slug', schoolSlug)
    .then(response => response.json())
    .then(result => {

      if (!result.campuses) {
        const section = document.querySelector('#school-contacts');
        const sectionContainer = section.querySelector('.container');
        const socialMedia = section.querySelector('.social-media');

        if (!socialMedia) {
          section.remove()
          return
        }
        sectionContainer.textContent = '';
        sectionContainer.appendChild(socialMedia);
        return
      }
      const map = initializeMap();

      result.campuses.forEach(campus => {

        map.setView([campus.lat, campus.long]);
        createNewCampusBox(campus.country, campus.city, campus.street, campus.lat, campus.long, map);

        let programs = '';
        campus.programs.forEach(program => programs += `${program.name} <br />`)

        addNewMarker(campus.lat, campus.long, customIcon, programs, map)

      });
    })
    .catch(error => console.log('error getting campuses', error))
}

document.addEventListener("DOMContentLoaded", () => {
  testimonialsSlider();
  gallery();
  openMediaInModal();
  changeContactsSectionOnMOb();

  //Load Map when it is in the viewport
  if ('IntersectionObserver' in window) {

    function handleIntersection(entries) {
      entries.map((entry) => {
        if (entry.isIntersecting) {
          // Item has crossed our observation
          mapWithCampuses();
          // Job done for this item - no need to watch it!
          observer.unobserve(entry.target);
        }
      });
    }

    const item = document.querySelector('#map');

    const observer = new IntersectionObserver(
      handleIntersection,
      { rootMargin: "100px" }
    );

    observer.observe(item);
} else {
  // No interaction support
  mapWithCampuses();
}


})


//  import _ from 'lodash';

//  function component() {
//     const element = document.createElement('div');
//    const button = document.createElement('button');
//    const br = document.createElement('br');

//    button.innerHTML = 'Click me and look at the console!';
//     element.innerHTML = _.join(['Hello', 'webpack'], ' ');
//    element.appendChild(br);
//    element.appendChild(button);

//    // Note that because a network request is involved, some indication
//    // of loading would need to be shown in a production-level site/app.
//    button.onclick = e => import(/* webpackChunkName: "print" */ './print').then(module => {
//      const print = module.default;

//      print();
//    });

//     return element;
//   }

//  document.body.appendChild(component());